import { AccountModel, ConcernSummary } from '../../lib/context/ConcernsContext';
import { IsSocketMessageBad } from './IsSocketMessageBad';
import {
  ImportStatusSummary,
  MarketplaceWorkerNotificationType,
  SocketMarketplaceWorkerNotificationModel
} from '../smartsend/SmartSendSocketsModels';

const GenerateSocketUpdates = (
  sockets: SocketMarketplaceWorkerNotificationModel[],
  account: AccountModel,
  title: string,
  stage: MarketplaceWorkerNotificationType
) => {
  const updates = sockets
    .filter((u) => u.Details?.MPAccountId === account.Id && u.Details?.Stage === stage)
    .sort((a, b) => {
      return b.Details.SentTime.valueOf() - a.Details.SentTime.valueOf();
    })
    .map((x) => x.Details);

  if (updates.length > 0) {
    return {
      SubTitle: title,
      Stage: stage,
      MPAccountId: account.Id,
      MarketplaceSource: account.SourceId,
      UserId: updates[0].UserId,
      SentTime: updates[0].SentTime,
      Updates: updates,
      IsError: !!updates.find((x) => IsSocketMessageBad(x)),
      Links: account.Links,
      MPAccountName: account.Description
    };
  }
  return null;
};

const ConvertConcernsStateToImportStatusSummary = (concernSummary: ConcernSummary): ImportStatusSummary[] => {
  const groups: ImportStatusSummary[] = [];

  if (!concernSummary || !concernSummary.Accounts || !concernSummary.Sockets) {
    return groups;
  }

  concernSummary.Accounts.forEach((account) => {
    const s: ImportStatusSummary = {
      IsError: false,
      MPAccountId: account.Id,
      MarketplaceSource: account.SourceId,
      UserId: account.Description,
      Import: GenerateSocketUpdates(concernSummary.Sockets, account, 'Import', 'import'),
      Sync: GenerateSocketUpdates(concernSummary.Sockets, account, 'Sync', 'syncshipped'),
      Update: GenerateSocketUpdates(concernSummary.Sockets, account, 'Updates', 'update')
    };
    s.IsError = s.Import?.IsError || s.Sync?.IsError || s.Update?.IsError;
    groups.push(s);
  });

  return groups;
};

export default ConvertConcernsStateToImportStatusSummary;
